/** Local imports */

import {reducer as user} from '~/common/fabric/User/reducers/user';
import {cachedMediaReducer} from '~/common/reducers/cachedMedia';
import {reducer as loginModal} from '~library/organisms/LoginModal/reducer';
import {favoritesReducer} from './favorites';
import {filtersReducer} from './filters';
import {galleryDataReducer} from './galleryData';

export const rootReducer = {
  galleryData: galleryDataReducer,
  favorites: favoritesReducer,
  filters: filtersReducer,
  cachedMedia: cachedMediaReducer,
  loginModal,
  user,
};
